// extracted by mini-css-extract-plugin
export default {"validationConfigSlider":"LogicChekcerSlider_validationConfigSlider__3MIsE"};